import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useDataValue } from 'Simple/Data.js'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let tx_id = useDataValue({
    context: 'treatment_card',
    path: 'txs._id',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)
  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value, originalValue, args, change }) {
    if (!value.location_id) return true

    let mutationResponse = await executeMutation({
      tx_id,
      organization_id: value.location_id,
    })

    if (mutationResponse.error) {
      return notify(
        notifyError(`Cannot update treatment's location. Please try again.`)
      )
    }

    notify(notifySuccess(`Treatment's location updated successfully`))

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
